import {connectStateResults} from "react-instantsearch-dom";
import React from "react";
import Col from "../primitives/grid/col";
import SearchSkeleton from "./search-skeleton";


// @ts-ignore
const NoResults = connectStateResults(({ isSearchStalled, searchResults }) => {

    if (!isSearchStalled && searchResults?.hits?.length === 0) {
        return (
            <Col
                breakpoints={{ dt: { span: 12 } }}
                css={{
                    padding: '32px',
                    textAlign: 'center',
                    width: '100%',
                }}
            >
                <h3 className="h3">Keine Ergebnisse</h3>
            </Col>
        )
    } else if (isSearchStalled) {
        return (
            <SearchSkeleton />
        )
    }
    return null
});

export default NoResults
